/* =====================================================================
   Filippo Loreti × Metal Slug — collab page behaviour
   One file for every "MS ·" section. Sections talk to each other through a
   tiny shared store (selected watch + strap) and data-attributes:

   [data-ms="<type>"]         section root, initialised once
   [data-ms-if="green|sand"]  shown only while that watch is selected
   [data-ms-pick-sel=...]     sets the selected watch ("green" | "sand" | "toggle")
   [data-ms-pick-strap=...]   sets the selected strap ("steel" | "rubber")
   [data-ms-join=...]         opens the join popup ("green" | "sand" | "all" | "sel")
   [data-ms-watch]            watch photo (see snippets/ms-watch.liquid)
   ===================================================================== */
(function () {
  'use strict';
  if (window.MSCollab) return;

  var RM = false;
  try { RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  var VIEWS = ['front', 'angled', 'lume', 'back'];
  var DEBUG = /[?&]ms_debug=1/.test(location.search);
  function dbg() { if (DEBUG && window.console) console.log.apply(console, ['%c[MS]', 'color:#F28C1B;font-weight:bold'].concat([].slice.call(arguments))); }
  var state = { sel: 'green', strap: 'steel' };

  /* ---------- helpers ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function pad2(n) { return (n < 10 ? '0' : '') + n; }
  function data(el, key) { try { return JSON.parse(el.querySelector('script[type="application/json"][data-' + key + ']').textContent); } catch (e) { return null; } }
  function other(v) { return v === 'sand' ? 'green' : 'sand'; }
  function scrollToEl(el) { if (el) el.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'start' }); }
  function storage(kind, key, val) {
    try {
      var s = window[kind];
      if (val === undefined) return s.getItem(key);
      s.setItem(key, val);
    } catch (e) { return null; }
  }
  function replayAnim(el, cls) { if (!el) return; el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); }

  /* watch photo URLs come from the image pickers of the section the watch lives in
     (snippets/ms-watch-map.liquid → <script data-ms-watchmap>) */
  function watchSrc(el, v, s, view) {
    var root = el.closest('.ms-root');
    if (!root) return null;
    if (!root.__msMap) root.__msMap = data(root, 'ms-watchmap') || {};
    return root.__msMap[v + '-' + s + '-' + view] || null;
  }
  /* update a [data-ms-watch] element: opts = { variant, strap, view } */
  function setWatch(el, opts) {
    var v = opts.variant || el.getAttribute('data-variant');
    var s = opts.strap || el.getAttribute('data-strap');
    var view = opts.view || el.getAttribute('data-view');
    var changed = v !== el.getAttribute('data-variant') || s !== el.getAttribute('data-strap');
    el.setAttribute('data-variant', v);
    el.setAttribute('data-strap', s);
    el.setAttribute('data-view', view);
    var name = (v === 'sand' ? 'Metal Slug Desert Raid' : 'Metal Slug Jungle Raid') + ' on ' + (s === 'steel' ? 'black steel bracelet' : 'rubber strap');
    $$('img', el).forEach(function (img) {
      var iv = el.hasAttribute('data-layers') ? img.getAttribute('data-v') : view;
      if (!el.hasAttribute('data-layers')) img.setAttribute('data-v', view);
      var src = watchSrc(el, v, s, iv);
      if (changed || !el.hasAttribute('data-layers')) {
        if (src) { if (img.getAttribute('src') !== src) { img.setAttribute('src', src); img.removeAttribute('width'); img.removeAttribute('height'); } }
        else img.removeAttribute('src');
      }
      var on = iv === view;
      img.classList.toggle('is-on', on);
      img.alt = on ? name + ', ' + (iv === 'back' ? 'caseback view' : iv === 'lume' ? 'glowing in the dark' : iv + ' view') : '';
    });
  }

  /* ---------- shared store ---------- */
  function setState(patch) {
    var changed = false;
    Object.keys(patch).forEach(function (k) { if (state[k] !== patch[k]) { state[k] = patch[k]; changed = true; } });
    if (changed) applyState(patch);
  }
  function applyState(patch) {
    patch = patch || state;
    $$('[data-ms-if]').forEach(function (el) { el.hidden = el.getAttribute('data-ms-if') !== state.sel; });
    $$('[data-ms-pick-sel]').forEach(function (el) {
      var v = el.getAttribute('data-ms-pick-sel');
      if (v === 'toggle') return;
      var on = v === state.sel;
      el.classList.toggle(el.getAttribute('data-on-class') || 'is-sel', on);
      el.setAttribute('aria-pressed', String(on));
    });
    $$('[data-ms-pick-strap]').forEach(function (el) {
      if (el.closest('[data-ms-local-strap]')) return;
      var on = el.getAttribute('data-ms-pick-strap') === state.strap;
      el.classList.toggle(el.getAttribute('data-on-class') || 'is-sel', on);
      el.setAttribute('aria-pressed', String(on));
    });
    $$('[data-ms-selcls]').forEach(function (el) { el.classList.remove('is-green', 'is-sand'); el.classList.add('is-' + state.sel); });
    $$('[data-ms-bg-green]').forEach(function (el) { el.style.background = el.getAttribute('data-ms-bg-' + state.sel); });
    $$('[data-ms-watch][data-bind]').forEach(function (el) {
      var b = el.getAttribute('data-bind');
      var o = {};
      if (b.indexOf('sel') >= 0) o.variant = state.sel;
      if (b.indexOf('strap') >= 0) o.strap = state.strap;
      setWatch(el, o);
    });
    if (patch.sel) $$('[data-ms-slidein]').forEach(function (el) { if (!RM) replayAnim(el, 'ms-slidein'); });
    document.dispatchEvent(new CustomEvent('ms:state', { detail: { sel: state.sel, strap: state.strap } }));
  }

  /* ---------- global click delegation ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-ms-pick-sel],[data-ms-pick-strap],[data-ms-join],[data-ms-scroll],[data-ms-replay-intro]');
    if (!t) return;
    if (t.hasAttribute('data-ms-pick-sel')) {
      var v = t.getAttribute('data-ms-pick-sel');
      setState({ sel: v === 'toggle' ? other(state.sel) : v });
    }
    if (t.hasAttribute('data-ms-pick-strap') && !t.closest('[data-ms-local-strap]')) setState({ strap: t.getAttribute('data-ms-pick-strap') });
    if (t.hasAttribute('data-ms-scroll')) {
      var target = $(t.getAttribute('data-ms-scroll'));
      scrollToEl(target);
      if (t.hasAttribute('data-ms-pulse') && target) {
        var btn = $('[data-ms-pulse-target]', target);
        if (btn && !RM) { replayAnim(btn, 'is-pulse'); setTimeout(function () { btn.classList.remove('is-pulse'); }, 1300); }
      }
    }
    if (t.hasAttribute('data-ms-join')) {
      e.preventDefault();
      var id = t.getAttribute('data-ms-join');
      if (id === 'sel') id = state.sel;
      if (t.hasAttribute('data-ms-pick-sel-on-join')) setState({ sel: t.getAttribute('data-ms-pick-sel-on-join') });
      openJoin(id, t.getAttribute('data-ms-strap') || state.strap, t);
    }
    if (t.hasAttribute('data-ms-replay-intro')) document.dispatchEvent(new CustomEvent('ms:replay-intro'));
  }, true);

  /* ---------- reveal on scroll ---------- */
  var io = null;
  function reveal(el) {
    if (RM || typeof IntersectionObserver === 'undefined') { el.classList.add('is-in'); return; }
    var r = el.getBoundingClientRect();
    if (r.top < window.innerHeight * 0.9) { el.classList.add('is-in'); return; }
    el.classList.add('is-pre');
    if (!io) {
      io = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.classList.remove('is-pre');
          en.target.classList.add('is-in');
          io.unobserve(en.target);
        });
      }, { threshold: 0.15 });
    }
    io.observe(el);
    setTimeout(function () { el.classList.remove('is-pre'); el.classList.add('is-in'); }, 9000);
  }

  /* ---------- portal (intro + popup live under <body>) ---------- */
  function portal(root) {
    var holder = root.closest('.ms-portal') || root;
    var sid = holder.getAttribute('data-section-id');
    if (sid) $$('.ms-portal[data-section-id="' + sid + '"]').forEach(function (p) { if (p !== holder && p.parentNode === document.body) p.remove(); });
    if (holder.parentNode !== document.body) document.body.appendChild(holder);
  }
  var scrollLocks = 0;
  function lockScroll(on) {
    scrollLocks = Math.max(0, scrollLocks + (on ? 1 : -1));
    document.documentElement.classList.toggle('ms-lock', scrollLocks > 0);
  }

  /* =====================================================================
     SECTION INITIALISERS
     ===================================================================== */
  var INIT = {};

  /* ----- INTRO ----- */
  INIT.intro = function (root) {
    var cfg = data(root, 'ms-config') || {};
    var intro = $('.ms-intro', root);
    if (!intro) return;
    portal(root);
    var timers = [];
    var segs = $$('.ms-seg', intro);
    var tank = $('.ms-tank', intro);
    var txt = $('[data-ms-prog]', intro);
    var belt = $('.ms-belt', intro);
    var startEl = $('.ms-istart-wrap', intro);
    var visible = false;
    function clear() { timers.forEach(clearTimeout); timers = []; }
    function prog(p) {
      var filled = Math.round(p * 0.6);
      segs.forEach(function (s, i) { s.classList.toggle('is-full', i < filled); });
      txt.textContent = p < 10 ? '00' + p : p < 100 ? '0' + p : '100';
      belt.setAttribute('aria-valuenow', p);
      tank.style.left = (6 + Math.floor(p / 10) * 8.6) + '%';
    }
    function done() { intro.hidden = true; intro.classList.remove('is-out'); if (visible) lockScroll(false); visible = false; }
    function out() { intro.classList.add('is-out'); timers.push(setTimeout(done, 720)); }
    function run() {
      clear();
      intro.hidden = false; intro.classList.remove('is-out');
      tank.classList.remove('is-off'); startEl.hidden = true;
      if (!visible) lockScroll(true);
      visible = true;
      prog(0);
      var steps = [[150, 7], [110, 15], [170, 23], [140, 31], [260, 37], [360, 42], [420, 47], [360, 53], [260, 61], [140, 72], [110, 83], [120, 92], [140, 100]];
      var t = 0;
      steps.forEach(function (s) { t += s[0]; timers.push(setTimeout(function () { prog(s[1]); }, t)); });
      t += 160; timers.push(setTimeout(function () { startEl.hidden = false; tank.classList.add('is-off'); tank.style.left = '115%'; }, t));
      t += 950; timers.push(setTimeout(out, t));
      storage('sessionStorage', 'ms_intro_seen', '1');
    }
    $('.ms-iskip', intro).addEventListener('click', function () { clear(); prog(100); out(); });
    document.addEventListener('ms:replay-intro', function () { if (!RM && intro.isConnected) { try { window.scrollTo(0, 0); } catch (e) {} run(); } });
    root.addEventListener('ms:editor-select', run);
    var designMode = window.Shopify && window.Shopify.designMode;
    var seen = cfg.oncePerSession && storage('sessionStorage', 'ms_intro_seen') === '1';
    if (cfg.enabled && !RM && !seen && !designMode) run(); else done();
  };

  /* ----- HEADER / BANNER / FOOTER: countdown + nothing else special ----- */
  function countdown(root) {
    $$('[data-ms-countdown]', root).forEach(function (cd) {
      var at = Date.parse(cd.getAttribute('data-ms-countdown'));
      if (isNaN(at)) return;
      var parts = { d: $('[data-u="d"]', cd), h: $('[data-u="h"]', cd), m: $('[data-u="m"]', cd), s: $('[data-u="s"]', cd) };
      var live = $('[data-ms-cd-live]', cd), dn = $('[data-ms-cd-done]', cd);
      function tick() {
        if (!cd.isConnected) return clearInterval(iv);
        var d = Math.max(0, at - Date.now());
        var t = Math.floor(d / 1000);
        if (parts.d) parts.d.textContent = pad2(Math.floor(t / 86400));
        if (parts.h) parts.h.textContent = pad2(Math.floor(t / 3600) % 24);
        if (parts.m) parts.m.textContent = pad2(Math.floor(t / 60) % 60);
        if (parts.s) parts.s.textContent = pad2(t % 60);
        if (live) live.hidden = d <= 0;
        if (dn) dn.hidden = d > 0;
        if (d <= 0) clearInterval(iv);
      }
      var iv = setInterval(tick, 1000);
      tick();
    });
  }
  INIT.header = function (root) { countdown(root); stickBelowThemeHeader(root); };

  /* Collab header sticks just BELOW whatever theme header is currently fixed/sticky at the top
     (Motion adds .site-header--stuck after ~250px and slides it in; Dawn uses a sticky section, etc.) */
  var THEME_HEADERS = '#SiteHeader, .site-header, #HeaderWrapper, sticky-header, .shopify-section-header-sticky, .section-header, .shopify-section-group-header-group, #shopify-section-header, #shopify-section-announcement-bar, header';
  function stickBelowThemeHeader(root) {
    var head = $('.ms-head', root);
    if (!head || !head.classList.contains('is-sticky')) return;
    var section = root.closest('.shopify-section') || root;
    var last = -1, until = 0, raf = 0;
    function measure() {
      var bottom = 0;
      $$(THEME_HEADERS).forEach(function (el) {
        if (el.closest('.ms-root')) return;
        var cs = getComputedStyle(el);
        if ((cs.position !== 'fixed' && cs.position !== 'sticky') || cs.display === 'none' || cs.visibility === 'hidden') return;
        var r = el.getBoundingClientRect();
        if (r.height > 0 && r.top <= 1 && r.bottom > 0 && r.bottom < window.innerHeight * 0.5) bottom = Math.max(bottom, r.bottom);
      });
      bottom = Math.round(bottom);
      if (bottom !== last) { last = bottom; section.style.setProperty('--ms-head-top', bottom + 'px'); dbg('collab header top =', bottom + 'px'); }
    }
    function loop() { measure(); raf = performance.now() < until ? requestAnimationFrame(loop) : 0; }
    function kick() { until = performance.now() + 700; if (!raf) raf = requestAnimationFrame(loop); } // follow slide-in animations
    window.addEventListener('scroll', kick, { passive: true });
    window.addEventListener('resize', kick);
    kick();
  }
  INIT.banner = countdown;
  INIT.footer = function () {};
  INIT.hero = function () {};
  INIT.pickups = function () {};

  /* ----- MISSION (arcade cabinet carousel) ----- */
  INIT.mission = function (root) {
    reveal(root);
    var slides = $$('.ms-cslide', root);
    var dots = $$('.ms-sdot', root);
    var btns = $$('.ms-abtn', root);
    var lbl = $('.ms-slide-lbl', root);
    var stat = $('.ms-static', root);
    var screen = $('.ms-screen', root);
    var labels = btns.map(function (b) { return b.getAttribute('data-label'); });
    var cur = 0, fx = 0;
    function go(i) {
      cur = (i + slides.length) % slides.length;
      fx++;
      var fxc = fx % 2 ? 'fx-a' : 'fx-b';
      slides.forEach(function (s, k) {
        s.classList.remove('is-on', 'is-left', 'is-right');
        s.classList.add(k === cur ? 'is-on' : k < cur ? 'is-left' : 'is-right');
        s.setAttribute('aria-hidden', String(k !== cur));
      });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === cur); });
      btns.forEach(function (b, k) { b.classList.toggle('is-on', k === cur); b.setAttribute('aria-pressed', String(k === cur)); });
      lbl.textContent = labels[cur] || '';
      [lbl, stat, screen].forEach(function (el) { el.classList.remove('fx-a', 'fx-b'); el.classList.add(fxc); });
    }
    btns.forEach(function (b, k) { b.addEventListener('click', function () { go(k); }); });
    $('.ms-stick.is-l', root).addEventListener('click', function () { go(cur - 1); });
    $('.ms-stick.is-r', root).addEventListener('click', function () { go(cur + 1); });
  };

  /* ----- KNOW YOUR GEAR (spec explorer) ----- */
  INIT.gear = function (root) {
    reveal(root);
    var SPECS = data(root, 'ms-specs') || [];
    var hints = data(root, 'ms-hints') || {};
    var watch = $('.ms-spec-watch [data-ms-watch]', root);
    var zoom = $('.ms-zoom', root);
    var rings = $('[data-ms-rings]', root);
    var scan = $('.ms-scanline', root);
    var hots = $$('.ms-hot', root);
    var accs = $$('.ms-acc-i', root);
    var hint = $('.ms-gear-hint', root);
    var flipBtn = $('[data-ms-flip]', root), lumeBtn = $('[data-ms-lume]', root);
    var st = { spec: -1, flip: false, lume: false };
    var lastScan = -1;
    var backIdx = SPECS.findIndex(function (x) { return x.view === 'back'; });

    function render() {
      var sp = st.spec >= 0 ? SPECS[st.spec] : null;
      var gView = st.flip ? 'back' : st.lume ? 'lume' : 'front';
      var spVis = sp && ((gView === 'back') === (sp.view === 'back'));
      var isWpn = !!sp && !!sp.weapon && gView !== 'back';
      var zs = spVis && !RM && gView !== 'back' && !isWpn ? (sp.r <= 10 ? 1.45 : sp.r <= 17 ? 1.2 : 1) : 1;
      var ax = sp ? sp.x : 50, ay = sp ? sp.y : 50;
      function zp(v, a) { return (1 - zs) * a + zs * v; }
      zoom.style.transform = 'translate(' + ((1 - zs) * ax).toFixed(2) + '%, ' + ((1 - zs) * ay).toFixed(2) + '%) scale(' + zs + ')';
      var strap = sp && sp.swap ? (state.strap === 'rubber' ? 'steel' : 'rubber') : state.strap;
      setWatch(watch, { variant: state.sel, strap: strap, view: gView });
      rings.hidden = !isWpn;
      // scan line sweeps once (2.4s) each time a spec is opened
      if (sp && st.spec !== lastScan) { scan.hidden = true; void scan.offsetWidth; }
      scan.hidden = !sp;
      lastScan = sp ? st.spec : -1;
      hots.forEach(function (h, i) {
        var x = SPECS[i]; if (!x) return;
        var hx = zp(x.x, ax), hy = zp(x.y, ay);
        h.style.left = hx.toFixed(2) + '%'; h.style.top = hy.toFixed(2) + '%';
        var off = ((gView === 'back') !== (x.view === 'back')) || hx < 3 || hx > 97 || hy < 3 || hy > 97;
        h.classList.toggle('is-on', st.spec === i);
        h.classList.toggle('is-off', off);
        h.setAttribute('aria-pressed', String(st.spec === i));
        h.tabIndex = off ? -1 : 0;
      });
      accs.forEach(function (a, i) {
        a.classList.toggle('is-open', st.spec === i);
        $('.ms-acc-h', a).setAttribute('aria-expanded', String(st.spec === i));
      });
      hint.textContent = st.flip ? hints.back : st.lume ? hints.lume : hints.idle;
      flipBtn.setAttribute('aria-pressed', String(st.flip));
      lumeBtn.setAttribute('aria-pressed', String(st.lume));
      $('[data-label]', flipBtn).textContent = st.flip ? flipBtn.getAttribute('data-on') : flipBtn.getAttribute('data-off');
      $('[data-label]', lumeBtn).textContent = st.lume ? lumeBtn.getAttribute('data-on') : lumeBtn.getAttribute('data-off');
    }
    function pick(i) {
      if (st.spec === i) { st.spec = -1; st.flip = false; st.lume = false; }
      else { var v = SPECS[i].view; st.spec = i; st.flip = v === 'back'; st.lume = v === 'lume'; }
      render();
    }
    hots.forEach(function (h, i) { h.addEventListener('click', function () { pick(i); }); });
    accs.forEach(function (a, i) { $('.ms-acc-h', a).addEventListener('click', function () { pick(i); }); });
    flipBtn.addEventListener('click', function () {
      if (st.flip) { st.flip = false; if (st.spec === backIdx) st.spec = -1; }
      else { st.flip = true; st.lume = false; st.spec = backIdx; }
      render();
    });
    lumeBtn.addEventListener('click', function () {
      if (st.lume) st.lume = false;
      else { st.lume = true; st.flip = false; if (st.spec >= 0 && SPECS[st.spec].view === 'back') st.spec = -1; }
      render();
    });
    document.addEventListener('ms:state', function () { if (root.isConnected) render(); });
    document.addEventListener('ms:gear-open', function (e) {
      if (!root.isConnected) return;
      st.spec = (e.detail && e.detail.spec) || 0; st.flip = false; st.lume = false;
      render();
      scrollToEl(root);
    });
    render();
  };

  /* ----- FINAL STAGE SELECT (cards with their own strap choice) ----- */
  INIT.select = function (root) {
    $$('[data-ms-card]', root).forEach(function (card) {
      var id = card.getAttribute('data-ms-card');
      // any button on a card selects that card's watch → Soldier strip (and gear / sticky bar) follow it
      card.addEventListener('click', function (e) { if (e.target.closest('button')) setState({ sel: id }); });
      var w = $('[data-ms-watch]', card);
      var claim = $('[data-ms-join]', card);
      var opts = $$('[data-ms-pick-strap]', card);
      opts.forEach(function (o) {
        o.addEventListener('click', function () {
          var s = o.getAttribute('data-ms-pick-strap');
          opts.forEach(function (x) { var on = x === o; x.classList.toggle('is-sel', on); x.setAttribute('aria-pressed', String(on)); });
          setWatch(w, { strap: s });
          claim.setAttribute('data-ms-strap', s);
        });
      });
      var more = $('[data-ms-explore]', card);
      if (more) more.addEventListener('click', function () {
        setState({ sel: id });
        document.dispatchEvent(new CustomEvent('ms:gear-open', { detail: { spec: 0 } }));
      });
    });
  };

  /* ----- STICKY BAR (mobile) ----- */
  INIT.sticky = function (root) {
    var bar = $('.ms-sticky', root);
    var after = parseInt(bar.getAttribute('data-after') || '0', 10);
    function upd() { bar.classList.toggle('is-hidden', window.scrollY < after || document.documentElement.classList.contains('ms-lock')); }
    window.addEventListener('scroll', upd, { passive: true });
    document.addEventListener('ms:popup', upd);
    upd();
  };

  /* =====================================================================
     JOIN POPUP — Klaviyo (client API) + Meta Pixel + dataLayer + Shopify analytics
     ===================================================================== */
  var join = null;

  INIT.join = function (root) {
    var cfg = data(root, 'ms-config') || {};
    portal(root);
    var over = $('.ms-over', root);
    var panel = $('.ms-over-panel', root);
    var form = $('form', root);
    var input = $('input[type="email"]', root);
    var consent = $('[data-ms-consent]', root);
    var hp = $('.ms-hp input', root);
    var err = $('.ms-join-err', root);
    var okBox = $('.ms-ok', root);
    var formBox = $('[data-ms-formbox]', root);
    var btn = $('button[type="submit"]', root);
    var w = $('.ms-over-watch [data-ms-watch]', root);
    var lastFocus = null;
    var ctx = { id: 'all', strap: 'steel' };

    function setErr(msg) { err.textContent = msg || ''; err.hidden = !msg; }

    function open(id, strap, from) {
      ctx = { id: id === 'green' || id === 'sand' ? id : 'all', strap: strap || 'steel' };
      lastFocus = from || document.activeElement;
      panel.classList.toggle('is-general', ctx.id === 'all');
      $$('[data-ms-pop]', root).forEach(function (el) { el.hidden = el.getAttribute('data-ms-pop') !== ctx.id; });
      if (ctx.id !== 'all') setWatch(w, { variant: ctx.id, strap: ctx.strap, view: 'front' });
      formBox.hidden = false; okBox.hidden = true; setErr('');
      btn.disabled = false;
      if (over.hidden) lockScroll(true);
      over.hidden = false;
      document.dispatchEvent(new CustomEvent('ms:popup', { detail: { open: true } }));
      setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); } }, 60);
      storage('sessionStorage', 'ms_popup_shown', '1');
    }
    function close() {
      if (over.hidden) return;
      over.hidden = true;
      lockScroll(false);
      document.dispatchEvent(new CustomEvent('ms:popup', { detail: { open: false } }));
      if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }
    join = { open: open, close: close };

    $$('[data-ms-close]', root).forEach(function (b) { b.addEventListener('click', close); });
    over.addEventListener('click', function (e) { if (e.target === over && cfg.closeOnBackdrop) close(); });
    document.addEventListener('keydown', function (e) {
      if (over.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') {
        var f = $$('button:not([disabled]),input:not([tabindex="-1"]),a[href]', panel).filter(function (x) { return x.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    var busy = false;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) return;
      if (hp && hp.value) { dbg('honeypot filled — ignored'); return; }
      var email = String(input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { setErr(cfg.msgInvalid); input.focus(); return; }
      if (consent && !consent.checked) { setErr(cfg.msgConsent); consent.focus(); return; }
      setErr('');
      busy = true; btn.disabled = true; btn.setAttribute('aria-busy', 'true');
      var interest = ctx.id === 'green' ? cfg.nameGreen : ctx.id === 'sand' ? cfg.nameSand : cfg.nameAll;
      var lead = { email: email, interest: interest, variant: ctx.id, strap: ctx.id === 'all' ? '' : ctx.strap };
      dbg('submit', lead);

      var kl = subscribe(cfg, lead).then(function () { dbg('Klaviyo: subscribed (202)'); return 'ok'; }, function (ex) { dbg('Klaviyo: failed', ex && ex.message); return ex; });
      var sh = cfg.shopifyBackup ? shopifyCustomer(form, lead, cfg).then(function () { dbg('Shopify customer: saved'); return 'ok'; }, function (ex) { dbg('Shopify customer: failed', ex && ex.message); return ex; }) : Promise.resolve(null);

      Promise.all([kl, sh]).then(function (res) {
        busy = false; btn.removeAttribute('aria-busy');
        var klOk = res[0] === 'ok', shOk = res[1] === 'ok';
        if (klOk || shOk) {
          formBox.hidden = true; okBox.hidden = false;
          storage('localStorage', 'ms_joined', '1');
          track(cfg, lead);
          var focusEl = $('[data-ms-close].ms-textbtn', root); if (focusEl) focusEl.focus();
          return;
        }
        btn.disabled = false;
        var kErr = res[0];
        setErr(kErr && kErr.invalidEmail ? cfg.msgInvalid : cfg.msgError);
        if (window.console) console.warn('[MS join] signup failed —', 'Klaviyo:', kErr && kErr.message, '| Shopify:', res[1] && res[1].message);
      });
    });

    // no-JS / fallback post to Shopify came back successfully → show the success state
    if ($('[data-ms-posted]', root)) { open('all', state.strap); formBox.hidden = true; okBox.hidden = false; }

    // theme editor: preview the popup when its section is selected
    root.addEventListener('ms:editor-select', function () { open(cfg.previewVariant || 'green', 'steel'); });
    root.addEventListener('ms:editor-deselect', close);

    // optional timed auto-open
    var delay = parseInt(cfg.autoDelay || 0, 10);
    var designMode = window.Shopify && window.Shopify.designMode;
    if (delay > 0 && !designMode && storage('localStorage', 'ms_joined') !== '1' && storage('sessionStorage', 'ms_popup_shown') !== '1') {
      setTimeout(function () { if (over.hidden && !document.documentElement.classList.contains('ms-lock')) open('all', state.strap); }, delay * 1000);
    }

    // load the Meta pixel base code on page load (if configured)
    if (cfg.fb && cfg.fb.enabled && cfg.fb.id && cfg.fb.load) withConsent(cfg, function (ok) { if (ok) fbLoad(cfg.fb); });
  };

  function openJoin(id, strap, from) {
    if (join) join.open(id, strap, from);
    else if (window.console) console.warn('[MS] Add the "MS · Join popup" section to this template.');
  }

  /* ---------- Klaviyo: client subscriptions API (public key only) ---------- */
  // Jungle popup → listGreen, Desert popup → listSand, general popup (and any empty raid list) → listId
  function listFor(k, variant) {
    if (variant === 'green' && k.listGreen) return k.listGreen;
    if (variant === 'sand' && k.listSand) return k.listSand;
    return k.listId;
  }
  function subscribe(cfg, lead) {
    var k = cfg.klaviyo || {};
    if (!k.publicKey || !k.listId) {
      if (window.console) console.warn('[MS join] Klaviyo public key / list ID missing in the "MS · Join popup" section settings.');
      return Promise.reject(new Error('Klaviyo not configured'));
    }
    var props = {};
    if (k.propInterest) props[k.propInterest] = lead.interest;
    if (k.propStrap && lead.strap) props[k.propStrap] = lead.strap;
    if (k.propPage) props[k.propPage] = location.pathname;
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: k.source || 'Metal Slug collab page',
          profile: { data: { type: 'profile', attributes: { email: lead.email, properties: props } } }
        },
        relationships: { list: { data: { type: 'list', id: listFor(k, lead.variant) } } }
      }
    };
    dbg('Klaviyo list', listFor(k, lead.variant), 'for', lead.variant);
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(k.publicKey), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: k.revision || '2026-10-15' },
      body: JSON.stringify(body),
      keepalive: true
    }).then(function (r) {
      if (r.status === 202 || r.ok) {
        try { if (k.identify && window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: lead.email }); } catch (e) {}
        return;
      }
      return r.text().then(function (t) {
        var ex = new Error('HTTP ' + r.status + ' ' + t);
        if (/email/i.test(t) && r.status === 400) ex.invalidEmail = true;
        throw ex;
      });
    });
  }

  /* ---------- Shopify customer (backup + works without JS): the form is {% form 'customer' %} ---------- */
  function shopifyCustomer(form, lead, cfg) {
    var fd = new FormData(form);
    fd.set('contact[email]', lead.email);
    var tags = [cfg.shopifyTags, lead.interest].filter(Boolean).join(', ');
    if (tags) fd.set('contact[tags]', tags);
    return fetch(form.getAttribute('action') || '/contact', { method: 'POST', body: fd, credentials: 'same-origin', headers: { Accept: 'text/html' } })
      .then(function (r) {
        if (/\/challenge/.test(r.url)) throw new Error('Shopify bot-protection challenge (captcha) — not saved');
        if (!r.ok) throw new Error('HTTP ' + r.status);
      });
  }

  /* ---------- consent (Shopify Customer Privacy API) ---------- */
  function withConsent(cfg, cb) {
    if (!cfg.respectConsent) return cb(true);
    var S = window.Shopify;
    try {
      if (S && S.customerPrivacy && S.customerPrivacy.marketingAllowed) return cb(S.customerPrivacy.marketingAllowed());
      if (S && S.loadFeatures) {
        return S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
          if (err || !S.customerPrivacy) return cb(true);
          cb(S.customerPrivacy.marketingAllowed());
        });
      }
    } catch (e) {}
    cb(true);
  }

  /* ---------- Meta (Facebook) Pixel ---------- */
  function fbLoad(fb) {
    if (!window.fbq) {
      /* eslint-disable */
      !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
      /* eslint-enable */
    }
    if (!window.__msFbInit) {
      window.__msFbInit = true;
      window.fbq('init', fb.id);
      if (fb.pageview) window.fbq('trackSingle', fb.id, 'PageView');
      dbg('Meta pixel loaded', fb.id);
    }
  }

  function track(cfg, lead) {
    var eventId = 'ms-lead-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);
    var payload = { content_name: lead.interest, content_category: 'Metal Slug collab', status: 'joined' };
    var fb = cfg.fb || {};
    if (fb.value) { payload.value = Number(fb.value); payload.currency = fb.currency || 'USD'; }

    withConsent(cfg, function (ok) {
      if (!ok) { dbg('Meta pixel: skipped — visitor has not given marketing consent'); return; }
      if (fb.enabled) {
        if (fb.load && fb.id) fbLoad(fb);
        if (window.fbq) {
          var ev = fb.event || 'Lead';
          var std = ['Lead', 'CompleteRegistration', 'Subscribe', 'Contact'].indexOf(ev) >= 0;
          // trackSingle sends the event only to this pixel ID (no double-counting with other pixels on the page)
          if (fb.id) window.fbq(std ? 'trackSingle' : 'trackSingleCustom', fb.id, ev, payload, { eventID: eventId });
          else window.fbq(std ? 'track' : 'trackCustom', ev, payload, { eventID: eventId });
          dbg('Meta pixel:', ev, payload, 'eventID', eventId);
        } else dbg('Meta pixel: fbq not available (blocked or not loaded)');
      }
    });
    // Google Tag Manager / GA4 via dataLayer
    if (cfg.dataLayer) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'ms_lead', ms_interest: lead.interest, ms_variant: lead.variant, ms_strap: lead.strap, event_id: eventId });
    }
    // Shopify customer events (usable from a Custom Pixel in Settings > Customer events)
    try { if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) window.Shopify.analytics.publish('ms_lead', { interest: lead.interest, variant: lead.variant, strap: lead.strap, event_id: eventId }); } catch (e) {}
  }

  /* =====================================================================
     BOOT
     ===================================================================== */
  function initAll(scope) {
    $$('[data-ms]', scope).forEach(function (el) {
      if (el.__msInit) return;
      el.__msInit = true;
      var fn = INIT[el.getAttribute('data-ms')];
      if (fn) try { fn(el); } catch (e) { if (window.console) console.error('[MS] init failed', el, e); }
    });
    applyState();
  }
  function boot() {
    var start = $('[data-ms-start]');
    if (start) state.sel = start.getAttribute('data-ms-start') === 'sand' ? 'sand' : 'green';
    initAll(document);
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var sid = e.detail && e.detail.sectionId;
    if (sid) $$('.ms-portal[data-section-id="' + sid + '"]').forEach(function (p) {
      var over = $('.ms-over', p); if (over && !over.hidden) lockScroll(false);
      var intro = $('.ms-intro', p); if (intro && !intro.hidden) lockScroll(false);
      if (over) join = null;
      p.remove();
    });
  });
  document.addEventListener('shopify:section:select', function (e) {
    var sid = e.detail && e.detail.sectionId;
    var p = sid && $('.ms-portal[data-section-id="' + sid + '"]');
    if (p) p.dispatchEvent(new CustomEvent('ms:editor-select'));
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var sid = e.detail && e.detail.sectionId;
    var p = sid && $('.ms-portal[data-section-id="' + sid + '"]');
    if (p) p.dispatchEvent(new CustomEvent('ms:editor-deselect'));
  });

  window.MSCollab = { state: state, setState: setState, openJoin: openJoin, setWatch: setWatch };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
